import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();
  return (
    <>
      <section
        // className="plan"
        // style={{ backgroundImage: `url(${BlueBgImage})` }}
        className="plan section-bg section-bg--white"
      >
        <div className="plan__container">
          <div className="column align-center">
            <div className="body primary">
              If you are not happy with our service, please write to Complaints
              Officer, Rosemount Financial Solutions (IFA) Ltd, Rosemount House,
              2-4 Chequers Road, Basingstoke, RG21 7PU. Telephone{" "}
              <span className="content-medium primary">
                <a href="tel:01256405460" className="primary">
                  01256 405460
                </a>
              </span>{" "}
              or{" "}
              <span className="content-medium primary">
                e-mail{" "}
                <a
                  href="mailto:complaints@rosemountfs.co.uk"
                  className="primary"
                >
                  complaints@rosemountfs.co.uk
                </a>
              </span>
            </div>
            <div className="body primary">
              A summary of our internal complaints handling procedures for the
              reasonable and prompt handling of complaints is available on
              request and if you cannot settle your complaint with us, you may
              be entitled to refer it to the financial Ombudsman Service at{" "}
              <a
                href="https://www.financial-ombudsman.org.uk"
                className="content-medium primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.financial-ombudsman.org.uk
              </a>{" "}
              or by contacting them on{" "}
              <a href="tel:08000234567" className="primary">
                0800 023 4567
              </a>
              .
            </div>
          </div>
        </div>
      </section>
      <section className=" plan section-bg section-bg--blue">
        <div className="plan__container">
          <div className="column align-center">
            <div
              className="help-text-regular underline"
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </div>
            <div className="help-text-regular">
              School Fees Protection Plan is a trading style of EDWARDCOOMBS LTD
              is an Appointed Representative of Rosemount Financial Solutions
              (IFA) Limited which is authorised and regulated by the Financial
              Conduct Authority. Rosemount Financial Solutions (IFA) Limited is
              entered on the Financial Services Register under reference 535515.
              EDWARDCOOMBS LTD is registered in England and Wales (Company
              Number: 16407001). Registered Address: 71-75 Shelton Street,
              Covent Garden, London, United Kingdom, WC2H 9JQ. The information
              on this website is subject to the UK regulatory regime and is
              intended for consumers in the UK.
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
